/**
 * useCountdown 是一个自定义 Hook，用于倒计时
 * @param initialTime 初始时间
 * @param onHalbzeit 剩余时间为初始时间的一半时触发的回调函数
 * @param onCountdown 倒计时结束时触发的回调函数
 * @returns 当前剩余时间
 */
import { useCallback, useEffect, useRef, useState } from 'react';

const useCountdown = (initialTime: number, onHalbzeit: () => void, onCountdown: () => void) => {
  const [count, setCount] = useState(initialTime);
  const [isText, setIsText] = useState(false)
  const interval = useRef<NodeJS.Timer>()
  const rate = 200;
  const initInterVal = useCallback(() => {
    if (isText) return;
    if (count === 0) return;
    interval.current = setInterval(() => {
      setCount((prevTime) => {
        const pre = prevTime - rate ;
        if (pre === initialTime / 2) {
          onHalbzeit();
        }
        if (pre === 0) {
          onCountdown();
          stopCountdown();
        }
        return pre;
      });
    }, rate);
  }, [count, initialTime, isText, onCountdown, onHalbzeit])
  useEffect(() => {
    initInterVal()
    return () => clearInterval(interval.current);
  }, [count]);

  const restartCountdown = (timer?: number) => {
    let timers = timer || initialTime
    clearInterval(interval.current);
    if (timers === count) {
      initInterVal()
    } else {
      setIsText(false)
      setCount(timers)
    }
  }
  const stopCountdown = () => clearInterval(interval.current);
  const setCountText = (num: number) => {
    setCount(num)
    setIsText(true)
    clearInterval(interval.current)
  };
  return { count, restartCountdown, stopCountdown, setCountText };
};
export default useCountdown;
